import React, { useState } from "react";
import HistoryTable from "./HistoryTable";
import EngineersTable from "./EngineersTable";
import MultitierTable from "./MultitierTable";
import ClaimedDailyTable from "./ClaimedDailyTable";
import ClaimedMultitierTable from "./ClaimedMultitierTable";
import NYOTable from "./NYOTable";
import { TfiReload } from "react-icons/tfi";
import ExtraREwardTable from "./ExtraREwardTable";
import PerfomanceRewardTable from "./PerfomanceRewardTable";

function DashbordTable() {
  const [showtab, setShowTab] = useState(0);
  return (
    <div>
      <div className="row">
        {" "}
        <div className="col-xl-12 my-3">
          <div className="new-card ">
            <div className="new-box">
              <div className="row px-2 align-items-center justify-content-between">
                <h4 className="ml-3">Analytics</h4>

                <div className="d-flex flex-wrap mt-3 mt-md-0 c-pointer">
                  <div
                    className={
                      showtab === 0
                        ? "px-3 py-2 h6 new-shadow "
                        : "px-3 py-2 h6"
                    }
                    onClick={() => setShowTab(0)}
                  >
                    NYO
                  </div>
                  <div
                    className={
                      showtab === 1
                        ? "px-3 py-2 h6 new-shadow "
                        : "px-3 py-2 h6"
                    }
                    onClick={() => setShowTab(1)}
                  >
                    Engineers
                  </div>
                  <div
                    className={
                      showtab === 2
                        ? "px-3 py-2 h6 new-shadow "
                        : "px-3 py-2 h6"
                    }
                    onClick={() => setShowTab(2)}
                  >
                    Daily
                  </div>
                  <div
                    className={
                      showtab === 3
                        ? "px-3 py-2 h6 new-shadow "
                        : "px-3 py-2 h6"
                    }
                    onClick={() => setShowTab(3)}
                  >
                    Multitier
                  </div>
                  <div
                    className={
                      showtab === 4
                        ? "px-3 py-2 h6 new-shadow "
                        : "px-3 py-2 h6"
                    }
                    onClick={() => setShowTab(4)}
                  >
                    Legacy Reward
                  </div>
                  <div
                    className={
                      showtab === 5
                        ? "px-3 py-2 h6 new-shadow "
                        : "px-3 py-2 h6"
                    }
                    onClick={() => setShowTab(5)}
                  >
                    Perfomance Reward
                  </div>
                  <div
                    className={
                      showtab === 6
                        ? "px-3 py-2 h6 new-shadow "
                        : "px-3 py-2 h6"
                    }
                    onClick={() => setShowTab(6)}
                  >
                    Claimed Daily
                  </div>
                  <div
                    className={
                      showtab === 7
                        ? "px-3 py-2 h6 new-shadow "
                        : "px-3 py-2 h6"
                    }
                    onClick={() => setShowTab(7)}
                  >
                    Claimed Multitier
                  </div>
                </div>
              </div>
            </div>
            <div className="new-box-body">
              {" "}
              <div className={showtab === 0 ? "d-block " : "d-none"}>
                <HistoryTable />{" "}
              </div>
              <div className={showtab === 1 ? "d-block " : "d-none"}>
                <EngineersTable />{" "}
              </div>
              <div className={showtab === 2 ? "d-block " : "d-none"}>
                <NYOTable />{" "}
              </div>
              <div className={showtab === 3 ? "d-block " : "d-none"}>
                <MultitierTable />{" "}
              </div>
              <div className={showtab === 4 ? "d-block " : "d-none"}>
                <ExtraREwardTable />{" "}
              </div>
              <div className={showtab === 5 ? "d-block " : "d-none"}>
                <PerfomanceRewardTable />{" "}
              </div>
              <div className={showtab === 6 ? "d-block " : "d-none"}>
                <ClaimedDailyTable />{" "}
              </div>
              <div className={showtab === 7 ? "d-block " : "d-none"}>
                <ClaimedMultitierTable />{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashbordTable;
